export default __webpack_public_path__ + "static/media/datang-hu-1point5-768x513.8c7a1e94.jpg";